import React from 'react';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetStaticProps } from 'next';
import { useTranslations } from 'next-intl';

import { courseConst, CoursesLanding, getTopTeachers, Search } from 'modules/courses';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();

  return (
    <>
      <NextHead title={t('meta.courses.title')} description={t('meta.courses.description')} />

      <div className="mx-auto my-7 min-h-screen max-w-screen">
        <Search />
        <CoursesLanding />
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  await Promise.allSettled([
    queryClient.prefetchQuery({
      queryKey: [courseConst.queryKeys.TOP_TEACHERS, 6],
      queryFn: getTopTeachers(6)
    })
    // queryClient.prefetchQuery({
    //   queryKey: [courseConst.queryKeys.TOP_COURSES],
    //   queryFn: getTopCourses()
    // }),
    // queryClient.prefetchQuery({
    //   queryKey: [courseConst.queryKeys.SORT_COURSES, 'desc', null, null, 8],
    //   queryFn: getCourses({ sortByCreatedAt: 'desc', size: 8 })
    // }),
    // queryClient.prefetchQuery({
    //   queryKey: [courseConst.queryKeys.CATEGORY_COURSES],
    //   queryFn: getCategoryCourses()
    // })
  ]);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      messages: (await import(`../../messages/${locale}.json`)).default
    },
    revalidate: 604800
  };
};
